import React from "react";
import { Form, FormLabel } from "react-bootstrap";
import { MyDebouncedSearch } from "../Common/MySearch";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import { isUserPermitted } from "../helpers/pageProps";

export default function ComponentLibraryFilter({ filters, setFilters }) {
  return (
    <div>
      <div className=" mb-3 bg-colored-reverse rounded-3 p-3 gap-2 align-items-center">
        {/* <FiltersIcon width={20} className="bg-white m-2 rounded" /> */}
        {/* <span className="fw-bold p-2">Filter options:</span>
          <div className="flex-grow-1">
            <Input
              isMulti
              onChange={() => null}
              value={["FILTER 1", "FILTER 2"]}
            />
          </div> */}
        <div className="row align-items-center">
          <div className="col-lg-3  ">
            <FormLabel>
              <span className="fw-bold p-2 text-white ">Status:</span>
            </FormLabel>
            <Input
              value={filters.status}
              onChange={(v) => setFilters((prev) => ({ ...prev, status: v }))}
              options={[
                { value: "production", label: "Production" },
                { value: "draft", label: "Draft" },
                { value: "archived", label: "Archived" },
              ]}
              isMulti
            />
          </div>
          <div className="col-lg-3">
            <FormLabel>
              <span className="fw-bold p-2 text-white ">Solution filter:</span>
            </FormLabel>
            <Form.Select
              aria-label="solutionFilter-select"
              onChange={(e) => {
                setFilters((prev) => ({
                  ...prev,
                  solutionFilter: e.target.value,
                }));
              }}
              value={filters.solutionFilter}
            >
              {isUserPermitted("edit_template") && (
                <option value="used">Used</option>
              )}
              <option value="imported">Imported</option>
              <option value="standalone">Standalone</option>
              <option value="any">Any</option>
            </Form.Select>
          </div>
          <div className="col-lg-3">
            <FormLabel>
              <span className="fw-bold p-2 text-white ">Order:</span>
            </FormLabel>{" "}
            <Form.Select
              aria-label="order-select"
              onChange={(e) => {
                setFilters((prev) => ({
                  ...prev,
                  order: e.target.value,
                }));
              }}
              value={filters.order}
            >
              <option value="created">Created</option>
              <option value="updated">Updated</option>
              <option value="label">Label</option>
              <option value="running">Running</option>
            </Form.Select>
          </div>
          <div className="col-lg-3">
            <FormLabel>
              <span className="fw-bold p-2 text-white ">Direction:</span>
            </FormLabel>
            <Form.Select
              aria-label="direction-select"
              onChange={(e) => {
                setFilters((prev) => ({
                  ...prev,
                  direction: e.target.value,
                }));
              }}
              value={filters.direction}
            >
              <option value="desc">desc</option>
              <option value="asc">asc</option>
            </Form.Select>
          </div>
        </div>
        <div className="mt-3">
          <FormLabel>
            <span className="fw-bold p-2 text-white ">Search </span>
          </FormLabel>
          <div>
            <MyDebouncedSearch
              placeholder="Search by label, description, reference"
              value={filters.label}
              onChange={(e) => {
                setFilters((prev) => ({ ...prev, label: e }));
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
